import { render, staticRenderFns } from "./OrderDocumentUploadModal.vue?vue&type=template&id=720b3c27"
import script from "./OrderDocumentUploadModal.vue?vue&type=script&lang=js"
export * from "./OrderDocumentUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports